import React from 'react'

// Clé localStorage de la faction CAD sélectionnée. Exportée car elle est écrite/lue en direct
// (hors `useStorageState`) là où la persistance doit être synchrone.
export const CAD_FACTION_STORAGE_KEY = 'CAD_FACTION_SELECTED'

const CadFactionContext = React.createContext({})

CadFactionContext.displayName = "CadFactionContext"

export default CadFactionContext
